import { css, SerializedStyles, Theme } from "@emotion/react";

export const checklistToggleButtonContainer = (
  { productFruits }: Theme,
  isCollapsed: boolean,
  shouldGlow: boolean,
): SerializedStyles => css`
  border-radius: 5px;

  display: inline-flex;
  line-height: 1;
  align-items: center;
  padding: 0rem 0.4rem 0 0.2rem;

  background-color: ${productFruits.checklistToggleButton.background};
  transition: background-color 0.2s ease;

  ${shouldGlow &&
  `
        @keyframes glow {
            0% {
                box-shadow: 0 0 8px ${productFruits.checklistToggleButton.backgroundGlowKeyframe};
            }
            50% {
                box-shadow: 0 0 20px ${productFruits.checklistToggleButton.background};
            }
            100% {
                box-shadow: 0 0 8px ${productFruits.checklistToggleButton.backgroundGlowKeyframe};
            }
        }
        animation: glow 1.5s ease-in-out infinite;
    `}

  letter-spacing: 0.1em;

  ${isCollapsed &&
  `
        margin-left: 2.5rem;
        background-color: ${productFruits.checklistToggleButton.backgroundCollapsed};
    `}

  &:hover {
    background-color: ${productFruits.checklistToggleButton.backgroundHover};
    cursor: pointer;
  }

  &:active {
    background-color: ${productFruits.checklistToggleButton.backgroundActive};
  }

  .button-text {
    color: ${productFruits.checklistToggleButton.text};
    user-select: none;
  }

  .checklist-icon {
    color: ${productFruits.checklistToggleButton.text};
  }
`;
